import ContributionService from '../../services/ContributionService'

const state = () => ({
    loadingContributions: false,
    contribution: null,
    contributions: [],
    total: 0,
    pages: 0,
    page: 1,
    show_modal_new_contribution: false
})
  
const mutations = {
    SET_CONTRIBUTION: (state, payload) => {
        state.contribution = payload
    },
    SET_CONTRIBUTIONS: (state, payload) => {
        if(payload.pageNumber == 1) {
            state.contributions = payload.itens
        }else{
            state.contributions = [...state.contributions, ...payload.itens]
        }
        state.page =  payload.pageNumber
        state.pages =  payload.pages
        state.total =  payload.total

    },
    SET_LOADING_CONTRIBUTIONS: (state, payload) => {
        state.loadingContribution = payload
    },
    SET_SHOW_MODAL_CONTRIBUTION: (state, payload) => {
        state.show_modal_new_contribution = payload
    },
}

const actions = {
    async fetchContribution({commit}, id){
        try{
            commit('SET_LOADING_CONTRIBUTIONS', true)
            const response = await ContributionService.getOne(id);
            commit('SET_CONTRIBUTION', response.data)
            commit('SET_LOADING_CONTRIBUTIONS', false)
        } catch (error) {
            commit('SET_LOADING_CONTRIBUTIONS', false);
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchContributions({commit, rootState}, { keyword = '', pageNumber = 1, sortBy = 'mais recentes' }){
        try{
            const id = rootState.user.user.id;
            commit('SET_LOADING_CONTRIBUTIONS', true)
            const response = await ContributionService.get(id, keyword, pageNumber, sortBy);
            commit('SET_CONTRIBUTIONS', response.data)
            commit('SET_LOADING_CONTRIBUTIONS', false)
        } catch (error) {
            commit('SET_LOADING_CONTRIBUTIONS', false);
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async createContribution({commit}, data){
        try{
            commit('SET_LOADING_CONTRIBUTIONS', true)
            const response = await ContributionService.create(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_SHOW_MODAL_CONTRIBUTION', false)
            commit('SET_LOADING_CONTRIBUTIONS', false)
        } catch (error) {
            commit('SET_LOADING_CONTRIBUTIONS', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async updadeContribution({commit}, data){
        try{
            commit('SET_LOADING_CONTRIBUTIONS', true)
            const response = await ContributionService.update(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_LOADING_CONTRIBUTIONS', false)
        } catch (error) {
            commit('SET_LOADING_CONTRIBUTIONS', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
}

const getters = {
    getContribution: state => state.contribution,
    getContributions: state => state.contributions,
    getLoadingContribution: state => state.loadingContribution,
    getShowModalNewContribution: state => state.show_modal_new_contribution
}

export default {
    state,
    getters,
    mutations,
    actions
};